import _slicedToArray from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.object.assign";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { Tooltip } from '@patternfly/react-core/dist/js/components/Tooltip/Tooltip';
export var HeaderCell = function HeaderCell(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'th' : _a$component,
      _a$scope = _a.scope,
      scope = _a$scope === void 0 ? '' : _a$scope,
      _a$textCenter = _a.textCenter,
      textCenter = _a$textCenter === void 0 ? false : _a$textCenter,
      _a$tooltip = _a.tooltip,
      tooltipProp = _a$tooltip === void 0 ? '' : _a$tooltip,
      _a$onMouseEnter = _a.onMouseEnter,
      onMouseEnterProp = _a$onMouseEnter === void 0 ? function () {} : _a$onMouseEnter,
      children = _a.children,
      isVisible = _a.isVisible,
      _a$dataLabel = _a.dataLabel,
      dataLabel = _a$dataLabel === void 0 ? '' : _a$dataLabel,
      props = __rest(_a, ["className", "component", "scope", "textCenter", "tooltip", "onMouseEnter", "children", "isVisible", "dataLabel"]);

  var mappedProps = Object.assign(Object.assign({}, scope ? {
    scope: scope
  } : {}), props);

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tooltip = _React$useState2[0],
      setTooltip = _React$useState2[1];

  var onMouseEnter = function onMouseEnter(event) {
    if (event.target.offsetWidth < event.target.scrollWidth) {
      setTooltip(tooltipProp || event.target.innerHTML);
    } else {
      setTooltip('');
    }

    onMouseEnterProp(event);
  };

  var Component = component;
  var cell = React.createElement(Component, Object.assign({}, mappedProps, {
    onMouseEnter: onMouseEnter,
    className: css(className, textCenter && styles.modifiers.center)
  }), children);
  return tooltip !== '' ? React.createElement(Tooltip, {
    content: tooltip
  }, cell) : cell;
};
HeaderCell.displayName = 'HeaderCell';